import { useContext } from 'react';
import { useAuthContext } from '../context/AuthContext';

// Legacy hook wrapper that now uses the global context
// This maintains backward compatibility with existing components
export const useAuth = () => {
  return useAuthContext();
};


